import { reactive } from 'vue';

const storedUser = JSON.parse(localStorage.getItem('zenphyr_user') || 'null');

export const auth = reactive({
  token: localStorage.getItem('zenphyr_token') || null,
  user: storedUser
    ? storedUser
    : { mid: null, url_perfil: null }
});

export function saveAuth(token, user) {
  auth.token = token;
  auth.user  = {
    mid: user.mid,
    url_perfil: user.url_perfil || null
  };
  localStorage.setItem('zenphyr_token', token);
  localStorage.setItem('zenphyr_user', JSON.stringify(auth.user));
}

// **Nova função para atualizar só a URL de perfil**
export function updateProfileUrl(url) {
  if (!auth.user) return;
  auth.user.url_perfil = url;
  // atualiza também no localStorage
  localStorage.setItem('zenphyr_user', JSON.stringify(auth.user));
}

export function clearAuth() {
  auth.token = null;
  auth.user  = { mid: null, url_perfil: null };
  localStorage.removeItem('zenphyr_token');
  localStorage.removeItem('zenphyr_user');
}
